import React, { memo } from 'react'

import { func, oneOf } from 'prop-types'

import Modal from 'Pods/Shared/Modal/Modal'

import AuthFlow from './AuthFlow'
import { MODE, STEP } from './constants'

function AuthModal({
  mode = MODE.SIGNUP,
  initialStep = STEP.AUTH,
  onClose: handleClose,
}) {
  return (
    <Modal
      isOpen
      width="large"
      customClass="auth-modal"
      ariaLabel={`${mode === MODE.LOGIN ? 'Log in' : 'Sign up'} to CGTrader`}
      onClose={handleClose}
    >
      <AuthFlow mode={mode} initialStep={initialStep} />
    </Modal>
  )
}

AuthModal.propTypes = {
  mode: oneOf([MODE.SIGNUP, MODE.LOGIN]),
  initialStep: oneOf([STEP.AUTH, STEP.CODE, STEP.SUCCESS]),
  onClose: func.isRequired,
}

export default memo(AuthModal)
